import axios from "axios";
import router from "@/router";
import { createToastInterface } from "vue-toastification";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const toast = createToastInterface();

// var API_BASE_URL = process.env.API_BASE_URL;
// var API_TIMEOUT = process.env.VUE_APP_API_TIMEOUT || 600000;

var API_BASE_URL = "https://gateway.mimebd.com";
var API_TIMEOUT = 600000;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    "Content-Type": "application/json",
    "X-Device-Auth": "CwRfMkURMJQJ",
  },
});

// -----------------------------
// REQUEST INTERCEPTOR
// -----------------------------
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// -----------------------------
// RESPONSE INTERCEPTOR
// -----------------------------
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (localStorage.getItem("accessToken") && status === 401) {
      localStorage.removeItem("accessToken");

      toast({
        component: ToastificationContent,
        props: {
          title: "Session expired, please login again",
          icon: "AlertCircleIcon",
          variant: "warning",
        },
      });

      router.push({ name: "login" });
    }

    return Promise.reject(error);
  },
);

export default api;
